// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
// ↓ 追記
require('jquery')
// require('chart')
// require('chart.js')
// //= require Chart.min


import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
// import "channels"
// // import Chart from 'chart.js/auto';
// import { Chart, registerables } from 'chart.js';
// Chart.register(...registerables);

import '@rails/ujs';
import '@rails/activestorage';
import 'turbolinks';
import 'popper.js'
// import 'bootstrap';
// import '../src/application.scss'
import $ from 'jquery';
import 'jquery-ujs';
// import { Chart, registerables } from 'chart.js';
import Papa from 'papaparse';
import * as XLSX from 'xlsx';
// import 'bootstrap/dist/js/bootstrap.bundle.min';
// import 'jstree';
// import jspreadsheet from 'jspreadsheet-ce';
// import 'jspreadsheet-ce/dist/jspreadsheet.css';
// import jsuites from 'jsuites';
// import 'jsuites/dist/jsuites.css';

Rails.start()
Turbolinks.start()
ActiveStorage.start()

// グローバルスコープに公開
window.$ = $;
window.jQuery = $;
// window.Chart = Chart;
window.Papa = Papa;
window.XLSX = XLSX;
// window.jspreadsheet = jspreadsheet;
// window.jsuites = jsuites;

// Chart.register(...registerables);